<template>
  <div class="goods-container">
    <component :is="goodsComponent" />
  </div>
</template>

<script>
import goodsType1 from './goods--type1/index.vue'
import goodsType2 from './goods--type2/index.vue'
import { getExpertConfig, getHomeData } from '@/api/cache'

export default {
  name: 'HomePage',
  components: {
    goodsType1,
    goodsType2
  },
  data() {
    return {
      state: {
        type: sessionStorage.getItem('templateId'), // 从接口/路由获取
      },
    }
  },

  computed: {
    goodsComponent() {
      const map = {
        100: goodsType1,
        101: goodsType1,
        102: goodsType1,
        103: goodsType1,
        104: goodsType2,
      }
      return map[this.state.type]
    },
  },

  created() {
    this.load()
    this.loadExpertConfig()
  },

  methods: {
    async load() {
      const { data } = await getHomeData()
      sessionStorage.setItem('homeData', JSON.stringify(data))
      this.state.type = data.templateId
      sessionStorage.setItem('templateId', data.templateId)
      sessionStorage.setItem('isSearchByImage', data?.expert?.isSearchByImage)
      this.state.homeInfo = data

      // 处理店铺主题
      if (data.storeTheme) {
        this._processStoreTheme(data.storeTheme)
      } else {
        this._processStoreTheme({})
      }
    },

    // 加载达人、装修主题
    async loadExpertConfig() {
      try {
        const { data } = await getExpertConfig()
        sessionStorage.setItem('expertConfig', JSON.stringify(data))
        // 设置favicon
        document.getElementById('dynamic-favicon').href = data.domainImage
        // 设置标题
        document.title = data.domainTitle
      } catch (error) {
        // 加载达人配置失败，请联系运营
        console.warn('Failed to load the expert configuration. Please contact the operator', error)
      }
    },

    // 处理主题
    _processStoreTheme(theme) {
      // 更新样式配置
      this.$styleManager.updateStyleConfig({
        primaryColor: theme.themeColor,
        backgroundColor: theme.bgColor,
        textColor: theme.selectFontColor || theme.themeColor,
        linkColor: theme.noselectFontColor,
        buttonColor: theme.themeColor
      })
    },
  }
}
</script>